export * from './depreciation/depreciation.component';
export * from './depreciation-expanded-collapse/depreciation-expanded-collapse.component';
export * from './edit-asset-detail/edit-asset-detail.component';
export * from './sale-dispose-asset/edit-dispose-asset.component';
export * from './rollback-popup/rollback-popup.component';
export * from './fixed-assest-dispose-active/fixed-assest-dispose-active.component';
